// extracted by mini-css-extract-plugin
export default {"container":"GFJegFzCU3wWqzaQlVh0"};